export const CHATTEL_SUBJECT_PROPERTY_TYPE_LABEL = 'Manufactured Housing';

export const chattelPropertySectionFieldsKeys = [
  'condition',
  'homeType',
  'sitePlacement',
  'landownerName',
  'landownerPhone',
  'parkName',
  'lotNumber',
  'locationDescription',
];
